import { retailRouterBeforeEach } from '@/router/hooks/retailRouterBeforeEach'
import { b2agRouterBeforeEach } from '@/router/hooks/b2agRouterBeforeEach'
import { isRetailContext } from '@invivodf/common/src/application/composables/useContext'
import type { Route } from 'vue-router'

export default async function routerBeforeEach(to: Route, from: Route, next) {
  if (isRetailContext()) {
    return retailRouterBeforeEach(to, from, next)
  }
  return b2agRouterBeforeEach(to, from, next)
}
